import axios from "axios";
import { GTMDataLayer } from "../services/gtm-datalayer";
//import { authHook } from "../services/helper-service";
export class AuthService {
    static async register(email: string, password: string, confirmPassword: string) {
        const params = new URLSearchParams();
        params.append("email", email);
        params.append("password", password);
        params.append("confirmPassword", confirmPassword);
        params.append("name", email);
        const response = await axios.post(`/account/registerasync`, params, {
            withCredentials: true,
        });
        const dt = response.data as { succeeded: boolean, statusCode: string | string[], errorDescription: string };
        if (dt.statusCode instanceof Array) {
            const s = dt.statusCode as string[];
            if (s.length > 0) dt.statusCode = s[0];
        }
        if(dt.succeeded) {
           GTMDataLayer.register(email);
        }
        return dt;
    }
    static async login(userName: string, password: string, rememberMe: boolean) {
        const params = new URLSearchParams();
        params.append("email", userName);
        params.append("password", password);
        params.append("rememberMe", rememberMe ? "true" : "false");
        const response = await axios.post(`/account/loginasync`, params, {
            withCredentials: true,
        });
        const dt = response.data as { succeeded: boolean, statusCode: string, isAdmin: boolean, url: string, id: string };
        if(dt.succeeded) {
            GTMDataLayer.login(dt.id);
        }
        return dt;
    }
    static async guestcheckout(email: string)
    {
        const params = new URLSearchParams();
        params.append("email", email);
        const response = await axios.post(`/account/guestloginasync`, params, {
            withCredentials: true,
        });
        const dt = response.data as { succeeded: boolean, statusCode: string, isAdmin: boolean, url: string };
        return dt;
    }
    static async isLoggedIn() {
        const response = await axios.post(`/account/check`, {}, {
            withCredentials: true
        });
        return response.data;
    }
    static async verifyCode(userName: string, code: string) {
        const params: URLSearchParams = new URLSearchParams();
        params.append("userName", userName);
        params.append("code", code);
        const response = await axios.post(`/account/ConfirmEmailAsync/`, params, {
            withCredentials: true
        });
        return response.data as {succeeded: boolean, statusCode: string};
    }
    static async getVerificationCode(userName: string) {
        const params: URLSearchParams = new URLSearchParams();
        params.append("userName", userName);
        const response = await axios.post(`/account/GetVerificationCode`, params, {
            withCredentials: true
        });
        return response.data as string;
    }
    static async resendVerificationCode(userName: string) {
        const params: URLSearchParams = new URLSearchParams();
        params.append("userName", userName);
        await axios.post(`/account/ResendVerificationLink`, params, {
            withCredentials: true
        });
    }
    static async logout() {
        const response = await axios.post(`/account/LogOffAsync`, {}, {
            withCredentials: true
        });
        return response.data;
    }
    static async forgotPassword(email: string){
        const params: URLSearchParams = new URLSearchParams();
        params.append("email", email);
        const response = await axios.post(`/api/account/forgotPassword`, params, {
            withCredentials: true
        });
        return response.data;
    }
    //@authHook
    static async attachGuestSessionToUser(sessionId: string) {
        const response = await axios.post(`/api/trx/attach-session/${sessionId}`, null, {
            withCredentials: true
        });
        return response.data;
    }
}
